`<template>
  <div class="bg" :class="{'bg_x':isIphoneX}">

    <div class="pid-container" v-if="pboxshow">
      <div class="pid-box" >
        <div class="pid-item" :class="{active:selectpid == 0}" @click="selectpat(0)">全部</div>
        <div
          class="pid-item"
          :class="{active:selectpid == item.id,female:item.sex==2}"
          v-for="(item,index) in pats"
          :key="index"
          @click="selectpat(item.id)"
        >
          <div class="pcontent">
            <p>{{item.realname}}</p>
            <span>{{item.sex==2?'女':'男'}}·{{item.age}}岁</span>
          </div>
          <i class="icon icon-picon" :class="{'icon-female':item.sex==2,'icon-male':item.sex==1}"></i>

        </div>
      </div>
    </div>

    <div class="chat-list">
      <div
        class="chat-list-item"
        @click="goChat(item.docid,item.p_id,item.hxgroupid,item.docname,index)"
        v-for="(item,index) in chat_process"
        :key="index"
      >
        <div class="chat-head">
          <img :src="item.docavatar" alt />
        </div>
        <div class="doc-content">
          <div class="chat-top">
            <span class="doc-name font-85">{{item.docname}}</span>
            <span class="doc-pos font-65">{{item.position}}</span>
            <span class="chat-time font-25">{{item.message_time/1000 | parseTime}}</span>
          </div>

          <div class="chat-content">
            <p class="font-25" >{{item.message_info?item.message_info:''}}</p>
            <span class="num-icon" v-if="item.message_num>0&&item.message_num<=99">{{item.message_num}}</span>
            <span class="num-icon" v-if="item.message_num>99">99+</span>
          </div>

          <div class="chat-btm">
            <div class="item-tags font-25">就诊人：{{item.username}}</div>
            <div
              class="item-tags"
              :class="{tuwen:item.type==1,shipin:item.type==3,yuyin:item.type==2}"
            >{{wenzhentype(item.type)}}</div>
          </div>
        </div>
      </div>
      <div class="doc-default" :class="{'doc-default-one':chat_process.length == 0 && pats.length<2}" v-if="chat_process.length==0">
        <img src="../../../static/icons/shuju@3x.jpg" alt />
        <div class="doc-default-txt font-85">暂无数据</div>
      </div>
    </div>
    <tabbar />
  </div>
</template>

<script>

  import tabbar from "./../../components/tabbar/tabbar.vue";
  import http from "../../request/http";
  import {formatTime} from '../../utils/index'

  export default {
  name: "chat_list",
  data() {
    return {
      pboxshow: true,
      selectpid: 0,
      sex: 2,
      wentype: 2,
      pats: [],
      chat_normal_list:[]
    };
  },
  filters:{
    parseTime(val){
      if(val){
        return formatTime(val)
      }else{
        return ''
      }
    }
  },
  components: {
    tabbar,
  },
  computed:{
    chats(){
      return this.$store.state.chat_list;
    },
    chat_process(){
      if(this.selectpid == 0){
        return this.chats;
      }else{
        return this.chat_normal_list
      }
    },
    isIphoneX(){
      return this.$store.state.isIphoneX;
    }
  },
  methods: {
    routerClick(path) {
      this.$router.push(path);
    },
    selectpat(pid) {
      this.selectpid = pid;
      this.chatList();
    },
    goChat(docid, pid, gid, name,index) {
      this.chats.forEach(v => {
        if(v.hxgroupid == gid){
          v.message_num = 0
        }
      })
      this.chat_normal_list.forEach(n => {
        if(n.hxgroupid == gid){
          n.message_num = 0
        }
      })
      this.$store.dispatch('getChatList',this.chats)
      this.$store.dispatch('getScrollTop',0)
      this.$router.push({
        name: "chat",
        query: {
          doctorid: docid,
          pid: pid,
          groupid: gid,
          name: name,
        },
      });
    },
    patList() {
      http.post("/api/wap/user/patientlist").then((res) => {
        //console.log(res)
        this.pats = res.data;
        // 如果就诊人少于两个就不显示全部等信息
        if(this.pats.length<=1){
          this.pboxshow = false;
        }
      });
    },
    groupList() {
      this.$imConn.listGroups({
        limit: 1000,
        success: (res) => {
          console.log(res);
        },
        error: (res) => {},
      });
    },
    chatList() {
      http
        .post("/api/wap/chat/doclist", {
          pid: this.selectpid,
        })
        .then((res) => {
          console.log(res.data)
          let list = [];
          this.chat_normal_list = [];
          console.log(this.chats,'4444555')
          if(this.chats.length>0){
            res.data.forEach(v => {
              this.chats.forEach(n => {
                if(n.hxgroupid == v.hxgroupid){
                  v = {...n,...v};
                }
              })
              list.push(v);
              this.chat_normal_list.push(v)
            })
          }else{
            res.data.forEach( v => {
              if(!v.message_num){
                v.message_num = 0;
              }
              let bodyjson;
              if(v.lastmsg && v.lastmsg.group_info){
                bodyjson = JSON.parse(v.lastmsg.group_info.body)
                if(!v.message_info){
                  if(bodyjson.ext.prescriptStatusType){
                    v.message_info = '[治疗方案]'
                  }else if (bodyjson.ext.tip && bodyjson.ext.tipStatusType == 1){
                    v.message_info = '[服务结束]'
                  }else if(bodyjson.ext.chatType && bodyjson.ext.chatType == 'IMAGE'){
                    v.message_info = '[图片]'
                  }else if(bodyjson.ext.chatType && bodyjson.ext.chatType == 'VOICE'){
                    v.message_info = '[语音]'
                  }else{
                    v.message_info = v.lastmsg.group_info.content;
                  }
                }
              }else{
                v.message_info = ""
              }
              if(!v.message_time){
                v.message_time = v.lastmsg?v.lastmsg.group_info.timestamp:'';
              }
              list.push(v);
              this.chat_normal_list.push(v)
            })
          }
          if(this.selectpid==0){
            this.$store.dispatch('getChatList',list);
          }
        });
    },
    wenzhentype(type) {
      switch (type) {
        case "1":
          return "图文咨询";
          break;
        case "2":
          return "电话咨询";
          break;
        default:
          return "视频咨询";

      }
    },
  },
  mounted() {
    this.patList();
    //this.groupList();
    this.chatList();
  },
};
</script>

<style scoped>
  .bg {
    background: #fafafa;
    min-height: 100vh;
    padding-bottom: 2.5rem;
  }
  .bg_x{
    padding-bottom: 3.5rem;
  }
  .doc-default {
    padding-top: 5rem;
    padding-bottom: 7rem;
  }
  .doc-default img {
    width: 15.9rem;
    height: 11rem;
    vertical-align: top;
    position: relative;
    left: 50%;
    transform: translate(-50%,0);
  }
  .doc-default-txt {
    width: 100%;
    height: 1.2rem;
    margin-top: 0.5rem;
    line-height: 1.2rem;
    font-size: 0.8rem;
    text-align: center;
  }
  .pid-box {
    width: 100%;
    height: 5.1rem;
    padding: 0.8rem 0.5rem 1.1rem;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
  }
  .pid-item {
    min-width: 6.4rem;
    width: auto;
    height: 3.2rem;
    padding: 0.5rem 0.6rem;
    border-radius: 0.4rem;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 0.2rem 0.4rem 0px rgba(0, 0, 0, 0.04);
    border: 0.05rem solid rgba(245, 245, 245, 1);
    float: left;
    font-size: 0.8rem;
    color: rgba(0, 0, 0, 0.25);
    margin-right: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .pid-item:first-child {
    min-width: 3.2rem;
    line-height: 2.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pid-item.active {
    background: #f0f5ff;
    border: 0.05rem solid rgba(214, 228, 255, 1);
    color: rgba(24, 144, 255, 1);
  }
  .pid-item.female.active {
    border: 0.05rem solid rgba(255, 214, 231, 1);
    background: #fff1f0;
    color: rgba(0, 0, 0, 0.85);
  }
  .pcontent {
    min-width: 3.2rem;
  }
  .pcontent p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .pcontent span {
    font-size: 0.6rem;
  }
  .icon-picon {
    width: 1.6rem;
    height: 1.6rem;
  }
  .pid-item.active .icon-male {

    content: url("https://images.dayiketang.com/boy_yes@2x.png");
  }
  .pid-item.active .icon-female {
    content: url("https://images.dayiketang.com/gril_yes@2x.png");
  }
  .icon-male {
    content: url("https://images.dayiketang.com/boy_no@2x.png");
  }
  .icon-female {
    content: url("https://images.dayiketang.com/girl_no@2x.png");
  }
  .chat-list {
    width: 100%;
    height: auto;
    background: #fff;
  }
  .chat-list-item {
    width: 100%;
    border-bottom: 0.05rem solid rgba(245, 245, 245, 1);
    padding: 0.9rem 0.5rem;
    display: flex;
    justify-content: space-between;
  }
  .chat-head {
    width: 2rem;
    margin-right: 1rem;
  }
  .chat-head img {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
  }
  .doc-content {
    float: right;
    width: 100%;
  }
  .doc-name {
    font-size: 0.9rem;
    font-weight: 700;
  }
  .doc-pos {
    font-size: 0.8rem;
  }
  .chat-time {
    float: right;
    font-size: 0.6rem;
  }
  .chat-content {
    height: 1.2rem;
    line-height: 1.2rem;
    font-size: 0.8rem;
    position: relative;
  }
  .chat-content p{
    width: calc(100vw - 5.15rem);
    height: 1.2rem;
    line-height: 1.2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .num-icon {
    height: 0.8rem;
    line-height: 0.8rem;
    font-size: 0.5rem;
    color: #fff;
    background: #fa541c;
    padding: 0 0.25rem;
    border-radius: 0.4rem;
    position: absolute;
    right: 0;
    top: 0.2rem;
  }
  .item-tags {
    display: inline-block;
    width: auto;
    height: 1rem;
    padding: 0.15rem 0.4rem;
    font-size: 0.7rem;
    background: #f5f5f5;
    border-radius: 0.5rem;
    line-height: 1;
  }
  .tuwen {
    color: #1890ff;
    background: #e6f7ff;
  }
  .shipin {
    color: #52c41a;
    background: #f6ffed;
  }
  .yuyin {
    color: #fa8c16;
    background: #fff7e6;
  }
  .chat-btm {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .chat-top {
    margin-bottom: 0.3rem;
  }
  .chat-content {
    margin-bottom: 0.75rem;
  }
  .pid-container{
    width: 100%;
    height: 4.8rem;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
  }
  .doc-default-one{
    height: calc(100vh - 2.5rem);
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/pages/chat_list/chat_list.vue